import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import {
    SovosBox,
    SovosMenuItem,
    SovosToolbar,
    SovosToolbarActions,
    SovosToolbarMoreMenu,
    SovosTypography,
} from "mosaic-react";
import { Download, PlayArrow } from "mosaic-react-icons";

export default function GeneratorLineMoreActions(props) {
    const { i18n, downloadFile, forceGenerateFile, reload, pushNotification } = useGlobalValue();
    const { value: cell } = props || {};
    const { name, entity, id, generationStatus } = cell || {};

    return (
        <SovosBox>
            <SovosToolbar
                sx={{
                    backgroundColor: "transparent !important",
                }}
            >
                <SovosToolbarActions>
                    <SovosToolbarMoreMenu
                        disabled={!["success", "pre_validation_failed"].includes(generationStatus)}
                    >
                        {generationStatus === "success" && (
                            <SovosMenuItem
                                onClick={() => {
                                    downloadFile({
                                        fileName: name,
                                        importId: id,
                                        id: `tooltip_${id}`,
                                        entity,
                                    }).catch(() => {
                                        pushNotification({
                                            open: true,
                                            message: i18n`Something went wrong!`,
                                            type: "error",
                                            timeout: "short",
                                        });
                                    });
                                }}
                            >
                                <Download />
                                <SovosTypography children={i18n`Download`} variant={"span"} />
                            </SovosMenuItem>
                        )}
                        {generationStatus === "pre_validation_failed" && (
                            <SovosMenuItem
                                onClick={() => {
                                    forceGenerateFile({
                                        id,
                                    }).then(() => {
                                        reload && reload();
                                    });
                                }}
                            >
                                <PlayArrow />
                                <SovosTypography children={i18n`Generate`} variant={"span"} />
                            </SovosMenuItem>
                        )}
                    </SovosToolbarMoreMenu>
                </SovosToolbarActions>
            </SovosToolbar>
        </SovosBox>
    );
}
